var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaDerecha24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5119 4.43057C12.8264 4.161 13.2999 4.19743 13.5694 4.51192L18.9001 10.731C19.526 11.4612 19.526 12.5388 18.9001 13.2691L13.5694 19.4881C13.2999 19.8026 12.8264 19.839 12.5119 19.5695C12.1974 19.2999 12.161 18.8264 12.4306 18.5119L17.3693 12.75L6 12.75C5.58579 12.75 5.25 12.4142 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25L17.3693 11.25L12.4306 5.48811C12.161 5.17361 12.1974 4.70014 12.5119 4.43057Z",
    fill: "#30ADD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaDerecha24X24);
export default __webpack_public_path__ + "static/media/FLECHA_DERECHA_24X24.f65d6298543b8cdf2f5132ad7603f7cf.svg";
export { ForwardRef as ReactComponent };